import { createIcon } from '@chakra-ui/react';

export const Volunteer = createIcon({
  displayName: 'Volunteer',
  viewBox: '0 0 64 64',
  path: (
    <>
      <rect
        id="bg"
        width="64"
        height="64"
        transform="translate(0 0)"
        fill="transparent"
      />
      <g id="SJ-Icon-B_Volunteer_Red_RGB" transform="translate(-0.998 -0.995)">
        <path
          id="Path_2217"
          data-name="Path 2217"
          d="M33,1a32,32,0,0,0-1.42,63.968h.068a1.549,1.549,0,0,0,.067-3.1,28.869,28.869,0,0,1-10.287-2.382V44.259a1.548,1.548,0,0,0-3.1,0V57.9a28.85,28.85,0,0,1-4.66-3.381v-10.4a6.2,6.2,0,0,1,6.193-6.193h7.367c.348,0,.7,0,1.024-.011.4-.012.795-.026,1.143-.064a19.086,19.086,0,0,0,2.472-.366,23.959,23.959,0,0,0,4.617-1.5,20.3,20.3,0,0,0,7.853-6.127,21.235,21.235,0,0,0,4.119-9.318l.019-.107a2.006,2.006,0,0,1,1.564-1.672,2.149,2.149,0,0,1,1.844.484,2.056,2.056,0,0,1,.69,1.668,24.988,24.988,0,0,1-1.138,6.215A25.082,25.082,0,0,1,48.7,32.885a25.355,25.355,0,0,1-9.489,8.63,24.578,24.578,0,0,1-2.944,1.28,1.548,1.548,0,0,0-1,1.448V63.2A1.548,1.548,0,0,0,37,64.733,31.994,31.994,0,0,0,33,1Zm5.36,60.4V45.305a23.159,23.159,0,0,0,2.3-1.056A28.464,28.464,0,0,0,51.3,34.556a28.147,28.147,0,0,0,3.077-6.472,28.029,28.029,0,0,0,1.282-6.98,5.134,5.134,0,0,0-1.72-4.166A5.254,5.254,0,0,0,49.5,15.715,5.109,5.109,0,0,0,45.422,19.9l-.019.106a18.115,18.115,0,0,1-3.508,7.944,17.208,17.208,0,0,1-6.656,5.2,20.88,20.88,0,0,1-4.02,1.311,16.137,16.137,0,0,1-2.1.312c-.319.033-.639.042-1.048.055-.231.009-.531.007-.827.005H19.861a9.3,9.3,0,0,0-9.289,9.289v7.146A28.925,28.925,0,1,1,38.357,61.393Z"
          fill="currentColor"
        />
        <path
          id="Path_2218"
          data-name="Path 2218"
          d="M27.741,15.165a7.985,7.985,0,1,0,7.985,7.985A7.993,7.993,0,0,0,27.741,15.165Zm0,12.873a4.888,4.888,0,1,1,4.888-4.888A4.894,4.894,0,0,1,27.741,28.038Z"
          transform="translate(0.603 0.455)"
          fill="currentColor"
        />
      </g>
    </>
  ),
});
